export function sortThreadsByDate(threads) {
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  const yesterday = new Date(today)
  yesterday.setDate(yesterday.getDate() - 1)

  const firstDayOfThisMonth = new Date(today.getFullYear(), today.getMonth(), 1)

  const sortedThreads = {
    today: [],
    yesterday: [],
    thisMonth: [],
    previous: [],
  }

  threads.forEach((thread) => {
    const updatedAt = new Date(thread.updated_at)
    updatedAt.setHours(0, 0, 0, 0)

    if (updatedAt.getTime() === today.getTime()) {
      sortedThreads.today.push(thread)
    } else if (updatedAt.getTime() === yesterday.getTime()) {
      sortedThreads.yesterday.push(thread)
    } else if (updatedAt >= firstDayOfThisMonth) {
      sortedThreads.thisMonth.push(thread)
    } else {
      sortedThreads.previous.push(thread)
    }
  })

  return sortedThreads
}
